import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import WorkflowSchedules from './WorkflowSchedules';
import './WorkflowSchedulesModal.css';

const WorkflowSchedulesModal = ({ open, onClose, projectId, projectName }) => {
  const handleOpenInNewTab = () => {
    window.open(`/project/schedules/${projectId}`, '_blank');
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="workflow-schedules-modal"
      aria-describedby="workflow-schedules-in-modal"
    >
      <Box className="workflow-schedules-modal-box">
        <AppBar position="static" elevation={0} className="workflow-schedules-modal-appbar">
          <Toolbar className="workflow-schedules-modal-toolbar">
            <div style={{ flexGrow: 1 }} />
            <IconButton color="inherit" onClick={handleOpenInNewTab} aria-label="open in new tab">
              <OpenInNewIcon />
            </IconButton>
            <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div className="workflow-schedules-modal-content">
          <WorkflowSchedules
            params={{ id: projectId }}
            location={{ state: { project_name: projectName } }}
            navigate={() => {}}
            isModal={true}
            onClose={onClose}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default WorkflowSchedulesModal;
